import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSuperPaySettings } from '../../data/SuperPayAPI';

export function useReadyForVerification() {
  const { data: superPaySettings } = useSuperPaySettings();

  return useMemo(() => {
    const [bankAccount = null] = superPaySettings?.bank_accounts ?? [];
    return (
      (bankAccount?.verification_status === 'new' ||
        bankAccount?.verification_status === 'pending') &&
      bankAccount.is_verification_available
    );
  }, [superPaySettings]);
}

export function useVerificationAvailable(
  fallBackUrl: string,
  options?: { skip?: boolean },
) {
  const navigate = useNavigate();
  const { search } = useLocation();
  const isReadyForVerification = useReadyForVerification();
  const skip = options?.skip ?? false;

  useEffect(() => {
    if (skip) return;
    if (!isReadyForVerification) {
      navigate({ pathname: fallBackUrl, search }, { replace: true });
    }
  }, [isReadyForVerification, search, fallBackUrl, navigate, skip]);
}
